import type { App } from "vue";
import { setupStore as setupBaseStore, createStore } from "@klondpay/stores";
import {
  setAppConfig,
  setEpThemeConfig,
  setSettingsConfig
} from "@klondpay/stores";
import { getConfig } from "/@/config";

// 立即创建并初始化 store 实例
const store = createStore();

// 初始化公共 Store 的配置获取方式
setAppConfig(getConfig as any);
setEpThemeConfig(getConfig as any);
setSettingsConfig(getConfig as any);

/**
 * 设置并安装 pinia
 */
export function setupStore(app: App<Element>) {
  return setupBaseStore(app);
}

export { store };
